import React from 'react';
import { Grid, Typography, Box, Button, Paper } from '@mui/material';
import { styles } from './styles';

import { Link } from 'gatsby-theme-material-ui';
import Location from '../Location/Location';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import MarketingLabel from '../EventCard/MarketingLabel';
import EventTypeLabel from '../EventsBlockCard/EventTypeLabel';

export default function SuggestEventCard(props) {
  const {
    title,
    location,
    isLoading,
    date,
    startTime,
    url_slug,
    external_url,
    clickHandler,
    shortDescription,
    subTitleEnum,
    isWide,
    ymMetriks,
    marketingLabel,
  } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        width: { xs: '100%' },
        maxWidth: 420,
        height: 388,
        p: (t) => t.spacing(!isWide ? 3 : 4),
        pt: { xs: 8, md: isWide ? 5 : 4 },
        position: 'relative',
        background: styles.backgroundGenerate(subTitleEnum),
        display: 'flex',
        flexDirection: 'column',
        border: { xs: 'none', lg: 'solid 1px lightgray' },
      }}
    >
      <EventTypeLabel
        type={subTitleEnum}
        additionalStyles={{ display: { xs: 'block', md: 'none' } }}
      />

      {marketingLabel && (
        <Box
          sx={{
            display: { xs: 'block', md: 'none' },
            position: 'absolute',
            top: 16,
            right: 10,
          }}
        >
          <MarketingLabel label={marketingLabel} />
        </Box>
      )}
      <Grid container columnGap={3} sx={{ width: '100%', minHeight: 192 }}>
        <Grid
          item
          xs={3.25}
          sx={{
            position: 'relative',
            '&::after': {
              content: '""',
              display: 'flex',
              position: 'absolute',
              height: '100%',
              width: '2px',
              backgroundColor: 'kit.text.h',
              right: '-14px',
              top: '50%',
              transform: 'translate(50%, -50%)',
            },
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              color: 'kit.infographic.darkPurple',
            }}
          >
            <Box
              sx={{
                maxWidth: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="desktopH4" sx={{ fontSize: 34 }}>
                {date[1]}
              </Typography>
              <Typography variant="desktopH4" sx={{ fontSize: 18 }}>
                {date[2]}
              </Typography>
              <Typography variant="desktopP3Helper" mt={1}>
                {date[0]}
              </Typography>
              <Typography variant="desktopH5" mt={1.5}>
                {startTime}
              </Typography>
              <Typography variant="desktopP3Helper" mt={0.5}>
                по Мск
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={7}>
          <Typography
            variant="desktopH4"
            sx={{
              maxWidth: 600,
              fontSize: 24,
              color: 'kit.text.main',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box !important',
              WebkitLineClamp: '3',
              lineClamp: '3',
              maxLines: '3',
              WebkitBoxOrient: 'vertical',
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="desktopP3"
            sx={{
              fontSize: 14,
              mt: 1.5,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box !important',
              WebkitLineClamp: '5',
              lineClamp: '5',
              maxLines: '5',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {shortDescription}
          </Typography>
        </Grid>
      </Grid>
      <Box
        sx={{
          mt: 3,
          width: '100%',
          pl: 0.5,
          fontSize: 14,
        }}
      >
        <Location location={location} />
        <Box
          sx={{
            display: 'flex',
            gap: 3.5,
            mt: 2,
            alignItems: 'center',
          }}
        >
          {!!clickHandler && (
            <Button
              variant="kitPrimary"
              size="medium"
              disabled={isLoading}
              onClick={clickHandler}
              sx={{ marginRight: '10px' }}
            >
              записаться
            </Button>
          )}
          <Link
            variant="kitPrimary"
            href={external_url || `/events/${url_slug}/`}
            target={external_url ? '_blank' : '_self'}
            sx={styles.link}
            onClick={() => sendYandexMetrikaEvent(ymMetriks.clickMore)}
          >
            Подробнее
          </Link>
        </Box>
      </Box>
    </Paper>
  );
}
